import classnames from 'classnames';
import { useEffect, type FunctionComponent } from 'react';

import styles from './Underlay.module.scss';

interface UnderlayProps {
  underlayVisible: boolean;
  clickUnderlay: () => void;
  zIndex: number;
}

export const Underlay: FunctionComponent<UnderlayProps> = ({
  underlayVisible = false,
  clickUnderlay,
  zIndex = 1,
}) => {
  function handleEscape(event: { code: string }) {
    return event.code !== 'Escape' || clickUnderlay();
  }
  useEffect(() => {
    document.addEventListener('keydown', handleEscape);
    return function cleanup() {
      document.removeEventListener('keydown', handleEscape);
    };
  });
  return (
    <div
      className={classnames([
        styles.underlay,
        underlayVisible && styles.underlayVisible,
      ])}
      onClick={clickUnderlay}
      style={{ zIndex }}
      role="button"
      onKeyDown={handleEscape}
      tabIndex={0}
    >
      &nbsp;
    </div>
  );
};

Underlay.displayName = 'Underlay';
